import React, { Component } from 'react';
import { Checkbox, Button, Modal } from 'carbon-components-react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import {
  listaCamisetas,
  listaAgasalhos
} from '../../../../redux/data/fluxoUniformesTrade';
import { Card } from '../../../../components';
import { getByDmService } from '../../../../services/Api';
import ItensExchanges from '../../../../components/trades/ItensExchanges';
import ConfirmExchangeUniform from './ConfirmExchangeUniform';

class ExchangeOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataRequest: {
        tamanhoCamiseta: null,
        tamanhoCamiseta2: null,
        tamanhoCamiseta3: null,
        tamanhoAgasalho: null
      },
      databaseValues: {
        tamanhoCamiseta: null,
        tamanhoCamiseta2: null,
        tamanhoCamiseta3: null,
        tamanhoAgasalho: null
      },
      formSelects: {
        tamanhoCamiseta: null,
        tamanhoCamiseta2: null,
        tamanhoCamiseta3: null,
        tamanhoAgasalho: null
      },
      showProps: {
        tamanhoCamiseta: false,
        tamanhoCamiseta2: false,
        tamanhoCamiseta3: false,
        tamanhoAgasalho: false
      },
      tShirtAll: false,
      tShirtOne: false,
      tShirtTwo: false,
      tShirtThree: false,
      coatFour: false,
      modalConfirm: false,
      nextExchange: false,
      goConfirm: false,
      confirmUniforms: null,
      openSize: false
    };
  }

  componentDidMount() {
    this.getUniform();
  }

  getUniform = () => {
    const { orderId } = this.props;
    const urlGet = `/Pedido/GetAssistente`;
    getByDmService(urlGet, orderId)
      .then(res => {
        const item = res.itensAssistente[0];
        this.setState({
          dataRequest: {
            tamanhoCamiseta: item.tamanhoCamiseta,
            tamanhoCamiseta2: item.tamanhoCamiseta2,
            tamanhoCamiseta3: item.tamanhoCamiseta3,
            tamanhoAgasalho: item.tamanhoAgasalho
          },
          databaseValues: {
            tamanhoCamiseta: item.tamanhoCamiseta,
            tamanhoCamiseta2: item.tamanhoCamiseta2,
            tamanhoCamiseta3: item.tamanhoCamiseta3,
            tamanhoAgasalho: item.tamanhoAgasalho
          }
        });
      })
      .catch(err => {
        console.log(err);
      });
  };

  confirmExchanges = option => {
    this.setState({
      goConfirm: true,
      confirmAll: option === 'all',
      confirmUniforms: option,
      modalConfirm: false
    });
  };

  cancel() {
    this.setState({
      modalConfirm: false
    });
  }

  selectedUniform(obj, id) {
    console.log("selectedUniform")
    console.log(obj);
    console.log(id);
    this.setState(prevState => ({
      ...prevState,
      dataRequest: {
        ...prevState.dataRequest,
        [id]: obj.value
      }
    }));
  }

  checkedAll = yes => {
    if (yes) {
      this.setState(prevState => ({
        ...prevState,
        showProps: {
          ...prevState.showProps,
          tamanhoCamiseta: true,
          tamanhoCamiseta2: true,
          tamanhoCamiseta3: true,
          tamanhoAgasalho: true
        },
        dataRequest: {
          ...prevState.dataRequest,
          tamanhoCamiseta: null,
          tamanhoCamiseta2: null,
          tamanhoCamiseta3: null,
          tamanhoAgasalho: null
        },
        tShirtAll: true,
        tShirtOne: true,
        tShirtTwo: true,
        tShirtThree: true,
        coatFour: true
      }));
    } else {
      this.setState(prevState => ({
        ...prevState,
        showProps: {
          ...prevState.showProps,
          tamanhoCamiseta: false,
          tamanhoCamiseta2: false,
          tamanhoCamiseta3: false,
          tamanhoAgasalho: false
        },
        dataRequest: {
          ...prevState.dataRequest,
          tamanhoCamiseta: null,
          tamanhoCamiseta2: null,
          tamanhoCamiseta3: null,
          tamanhoAgasalho: null
        },
        tShirtAll: false,
        tShirtOne: false,
        tShirtTwo: false,
        tShirtThree: false,
        coatFour: false
      }));
    }
  };

  markChecked = (yes, check) => {
    switch (check) {
      case 'tShirtAll':
        this.checkedAll(yes);
        break;
      case 'tShirtOne':
        this.setState(prevState => ({
          ...prevState,
          showProps: {
            ...prevState.showProps,
            tamanhoCamiseta: !!yes
          },
          dataRequest: {
            ...prevState.dataRequest,
            tamanhoCamiseta: null
          },
          tShirtOne: !!yes
        }));
        break;
      case 'tShirtTwo':
        this.setState(prevState => ({
          ...prevState,
          showProps: {
            ...prevState.showProps,
            tamanhoCamiseta2: !!yes
          },
          dataRequest: {
            ...prevState.dataRequest,
            tamanhoCamiseta2: null
          },
          tShirtTwo: !prevState.tShirtTwo
        }));
        break;
      case 'tShirtThree':
        this.setState(prevState => ({
          ...prevState,
          showProps: {
            ...prevState.showProps,
            tamanhoCamiseta3: !!yes
          },
          dataRequest: {
            ...prevState.dataRequest,
            tamanhoCamiseta3: null
          },
          tShirtThree: !!yes
        }));
        break;
      case 'coatFour':
        this.setState({ coatFour: !!yes });
        this.setState(prevState => ({
          ...prevState,
          showProps: {
            ...prevState.showProps,
            tamanhoAgasalho: !!yes
          },
          dataRequest: {
            ...prevState.dataRequest,
            tamanhoAgasalho: null
          },
          coatFour: !!yes
        }));
        break;
      default:
        return false;
    }
    return false;
  };

  checkedsIsTrue() {
    const { tShirtOne, tShirtTwo, tShirtThree, coatFour } = this.state;

    if (tShirtOne || tShirtTwo || tShirtThree || coatFour) {
      return true;
    }
    return false;
  }

  openModalMedidas() {
    this.setState({
      openSize: true
    });
  }

  closeModalMedidas() {
    this.setState({
      openSize: false
    });
  }

  openModal = () => {
    const {
      tShirtOne,
      tShirtTwo,
      tShirtThree,
      coatFour,
      dataRequest
    } = this.state;

    if (
      dataRequest.tamanhoCamiseta &&
      dataRequest.tamanhoCamiseta2 &&
      dataRequest.tamanhoCamiseta3 &&
      dataRequest.tamanhoAgasalho
    ) {
      if (tShirtOne && tShirtTwo && tShirtThree && coatFour) {
        this.setState({ goConfirm: true });
      } else {
        this.setState({ modalConfirm: true });
      }
    } else {
      toast.warn('Você precisa informar por qual tamanho deseja trocar.');
    }
  };

  closeModal = () => {
    this.setState({ modalConfirm: false });
    this.returnSearchTrades();
  };

  returnSearchTrades = () => {
    window.location.href = '/trade/uniformes';
  };

  nextView = () => {
    const isCheckeds = this.checkedsIsTrue();

    if (isCheckeds) {
      this.setState({ nextExchange: true });
    } else {
      toast.warn('Você precisa selecionar as peças do kit que deseja trocar.');
    }
  };

  returnExchanges = () => {
    this.setState({ nextExchange: false });
  };

  returnConfirm = () => {
    this.setState({ goConfirm: false });
  };

  render() {
    // dataRequest e dataBaseValues servem para comparar os valores modificados pelos originais vindos do banco
    // showProps contem propiedades com booleanos e serve para mostrar os itens que estão e/ou devem ser modificados
    // nextExchange se true manda para página com os itens que devem ser trocados.

    const {
      dataRequest,
      nextExchange,
      goConfirm,
      tShirtAll,
      tShirtOne,
      tShirtTwo,
      tShirtThree,
      coatFour,
      modalConfirm,
      confirmUniforms,
      databaseValues,
      showProps,
      openSize
    } = this.state;
    const { cleark, returnSearch, orderId } = this.props;
    return (
      <div>
        <Card className="center-box box-padd">
          {nextExchange &&
            !goConfirm && (
              <div className="bx--row">
                <div className="bx--col-xs-8">
                  <p className="description-option-title ">
                    Por qual(is) tamanho(s) você deseja trocar?
                  </p>
                  <p className="description-option-desc">
                    Selecione a(s) peça(s) que você gostaria de trocar.
                  </p>
                </div>
                <div className="bx--col-xs-4">
                  <a
                    onClick={() => this.openModalMedidas()}
                    className="link-dm pointer f-right"
                  >
                    Ver Medidas
                  </a>
                </div>
                <div className="bx--col-xs-12">
                  {tShirtOne && (
                    <div className="mg-top-20">
                      <div className="bx--row mg-top-10">
                        <div className="bx--col-xs-12 bx--col-md-2">
                          Camiseta #1
                        </div>
                        <div className="bx--col-xs-12 bx--col-md-7">
                          <Select
                            value={dataRequest.tamanhoCamiseta}
                            label="Digite o nome do atendente."
                            placeholder="Tamanho"
                            options={listaCamisetas}
                            onChange={e =>
                              this.selectedUniform(e, 'tamanhoCamiseta')
                            }
                            className="search-dm"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {tShirtTwo && (
                    <div className="mg-top-20">
                      <div className="bx--row mg-top-10">
                        <div className="bx--col-xs-12 bx--col-md-2">
                          Camiseta #2
                        </div>
                        <div className="bx--col-xs-12 bx--col-md-7">
                          <Select
                            value={dataRequest.tamanhoCamiseta2}
                            label="Digite o nome do atendente."
                            placeholder="Tamanho"
                            options={listaCamisetas}
                            onChange={e =>
                              this.selectedUniform(e, 'tamanhoCamiseta2')
                            }
                            className="search-dm"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {tShirtThree && (
                    <div className="mg-top-20">
                      <div className="bx--row mg-top-10">
                        <div className="bx--col-xs-12 bx--col-md-2">
                          Camiseta #3
                        </div>
                        <div className="bx--col-xs-12 bx--col-md-7">
                          <Select
                            value={dataRequest.tamanhoCamiseta3}
                            label="Digite o nome do atendente."
                            placeholder="Tamanho"
                            options={listaCamisetas}
                            onChange={e =>
                              this.selectedUniform(e, 'tamanhoCamiseta3')
                            }
                            className="search-dm"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {coatFour && (
                    <div className="mg-top-20">
                      <div className="bx--row mg-top-10">
                        <div className="bx--col-xs-12 bx--col-md-2">
                          Agasalho
                        </div>
                        <div className="bx--col-xs-12 bx--col-md-7">
                          <Select
                            value={dataRequest.tamanhoAgasalho}
                            label="Digite o nome do atendente."
                            placeholder="Tamanho"
                            options={listaAgasalhos}
                            onChange={e =>
                              this.selectedUniform(e, 'tamanhoAgasalho')
                            }
                            className="search-dm"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          {!nextExchange &&
            !goConfirm && (
              <div className="bx--row">
                <div className="bx--col-xs-8">
                  <p className="description-option-title ">
                    O que você deseja trocar?
                  </p>
                  <p className="description-option-desc">
                    Selecione a(s) peça(s) que você gostaria de trocar.
                  </p>
                </div>
                <div className="bx--col-xs-4">
                  <a
                    onClick={() => this.openModalMedidas()}
                    className="link-dm f-right pointer"
                  >
                    Ver Medidas
                  </a>
                </div>
                <div className="bx--col-xs-12">
                  <div className="mg-top-20">
                    <div className="bx--row mg-top-10">
                      <div className="bx--col-xs-12 bx--col-md-3">
                        <Checkbox
                          className="some-class"
                          onChange={e => this.markChecked(e, 'tShirtAll')}
                          labelText="Selecionar todos"
                          checked={tShirtAll}
                          id="tShirtAll"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mg-top-20">
                    <div className="bx--row mg-top-10">
                      <div className="bx--col-xs-12 bx--col-md-3">
                        <Checkbox
                          className="some-class"
                          onChange={e => this.markChecked(e, 'tShirtOne')}
                          labelText="Camiseta #1"
                          checked={tShirtOne}
                          id="tShirtOne"
                        />
                      </div>
                      <div className="bx--col-xs-12 bx--col-md-5">
                        <Select
                          value={databaseValues.tamanhoCamiseta}
                          label="Digite o nome do atendente."
                          placeholder="Tamanho"
                          options={listaCamisetas}
                          onChange={e => this.selectedUniform(e, 'tShirtOne')}
                          disabled
                          className={
                            databaseValues.tamanhoCamiseta
                              ? 'search-dm select-dm blocked-hover'
                              : 'search-dm select-dm'
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mg-top-20">
                    <div className="bx--row mg-top-10">
                      <div className="bx--col-xs-12 bx--col-md-3">
                        <Checkbox
                          className="some-class"
                          onChange={e => this.markChecked(e, 'tShirtTwo')}
                          labelText="Camiseta #2"
                          checked={tShirtTwo}
                          id="tShirtTwo"
                        />
                      </div>
                      <div className="bx--col-xs-12 bx--col-md-5">
                        <Select
                          value={databaseValues.tamanhoCamiseta2}
                          label="Digite o nome do atendente."
                          placeholder="Tamanho"
                          options={listaCamisetas}
                          onChange={e => this.selectedUniform(e, 'tShirtTwo')}
                          disabled
                          className={
                            databaseValues.tamanhoCamiseta2
                              ? 'search-dm select-dm blocked-hover'
                              : 'search-dm select-dm'
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mg-top-20">
                    <div className="bx--row mg-top-10">
                      <div className="bx--col-xs-12 bx--col-md-3">
                        <Checkbox
                          className="some-class"
                          onChange={e => this.markChecked(e, 'tShirtThree')}
                          labelText="Camiseta #3"
                          checked={tShirtThree}
                          id="tShirtThree"
                        />
                      </div>
                      <div className="bx--col-xs-12 bx--col-md-5">
                        <Select
                          value={databaseValues.tamanhoCamiseta3}
                          label="Digite o nome do atendente."
                          placeholder="Tamanho"
                          options={listaCamisetas}
                          onChange={e => this.selectedUniform(e, 'tShirtThree')}
                          disabled
                          className={
                            databaseValues.tamanhoCamiseta3
                              ? 'search-dm select-dm blocked-hover'
                              : 'search-dm select-dm'
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mg-top-20">
                    <div className="bx--row mg-top-10">
                      <div className="bx--col-xs-12 bx--col-md-3">
                        <Checkbox
                          className="some-class"
                          onChange={e => this.markChecked(e, 'coatFour')}
                          labelText="Agasalho"
                          checked={coatFour}
                          id="coatFour"
                        />
                      </div>
                      <div className="bx--col-xs-12 bx--col-md-5">
                        <Select
                          value={databaseValues.tamanhoAgasalho}
                          label="Digite o nome do atendente."
                          placeholder="Tamanho"
                          options={listaAgasalhos}
                          onChange={e => this.selectedUniform(e, 'coatFour')}
                          disabled
                          className={
                            databaseValues.tamanhoAgasalho
                              ? 'search-dm select-dm blocked-hover'
                              : 'search-dm select-dm'
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          {goConfirm && (
            <ConfirmExchangeUniform
              dataUniforms={dataRequest}
              orderId={orderId}
              cleark={cleark}
              confirmUniforms={confirmUniforms}
              valueOrigins={databaseValues}
              showProps={showProps}
              returnConfirm={this.returnConfirm}
            />
          )}
          {nextExchange &&
            !goConfirm && (
              <div className="bx--row">
                <div className="bx--col-xs-12 v-md-margin buttons-footer-requests">
                  <Button onClick={() => this.openModal()}> Avançar </Button>
                  <Button
                    onClick={() => this.returnExchanges()}
                    kind="ghost"
                    className="h-sm-margin"
                  >
                    Voltar
                  </Button>
                </div>
              </div>
            )}
          {!nextExchange &&
            !goConfirm && (
              <div className="bx--row">
                <div className="bx--col-xs-12 v-md-margin buttons-footer-requests">
                  <Button onClick={() => this.nextView()}> Avançar </Button>
                  <Button
                    onClick={returnSearch}
                    kind="ghost"
                    className="h-sm-margin"
                  >
                    Voltar
                  </Button>
                </div>
              </div>
            )}
        </Card>
        <div>
          <Modal
            onRequestClose={() => this.cancel()}
            onRequestSubmit={() => this.confirmExchanges('all')}
            iconDescription="Fechar"
            className="some-class"
            open={modalConfirm}
            modalHeading="Aviso."
            primaryButtonText="Sim, tenho certeza."
            secondaryButtonText="Cancelar"
          >
            <div className="warning-modal-txt">
              <ItensExchanges dataRequest={dataRequest} showProps={showProps} />
            </div>
          </Modal>

          <Modal
            onRequestClose={() => this.closeModalMedidas()}
            onRequestSubmit={() => this.closeModalMedidas()}
            iconDescription="Fechar"
            className="some-class modal-medidas"
            open={openSize}
            modalHeading="Medidas."
            primaryButtonText="Ok, entendi."
          >
            <img
              className="img-responsive"
              src={require('../../../../assets/images/sizesshirt.jpg')}
              alt=""
            />
          </Modal>
        </div>
      </div>
    );
  }
}

export default ExchangeOrder;



// WEBPACK FOOTER //
// ./src/screens/client/trades/uniforms/ExchangeOrder.jsx